import { Game } from '../game.model';
import { Player } from '../player.model';

export class Unspectated {
  game: Game;
  player: Player;
}
